import styled from 'styled-components';
import { Column } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';
import { Button } from '@simplywallst/ui-core';
import CaretRight from '@assets/images/icons/legacy/chevron-right.svg';
import { RouterLink } from '@/utilities/redux-first-router.export';

export const NavBarList = styled('ul')`
  list-style: none;
  margin-bottom: 0;
  display: flex;
  align-items: center;
`;

export const NavBarItem = styled('li')`
  display: inline-block;
  padding-right: ${({ theme }) => theme.x2spacePx}px;
  padding-left: ${({ theme }) => theme.x2spacePx}px;
  ${media.smUp`
    padding-right: ${({ theme }) => theme.x1spacePx}px;
    padding-left: ${({ theme }) => theme.x2spacePx}px;
  `}
`;

interface NavLinkProps {
  readonly $isWhite?: boolean;
}

export const NavAnchor = styled('a')<NavLinkProps>`
  cursor: pointer;
  text-decoration: none;
  color: ${(props) =>
    props.$isWhite ? props.theme.color.white : props.theme.color.spaceGray};
  ${({ theme }) => theme.typography.xSmallStrong}
  &:hover {
    color: ${({ theme }) => theme.color.brand01};
  }
`;

export const NavRouterLink = styled(RouterLink)<NavLinkProps>`
  cursor: pointer;
  text-decoration: none;
  color: ${(props) =>
    props.$isWhite ? props.theme.color.white : props.theme.color.spaceGray};
  ${({ theme }) => theme.typography.xSmallStrong}
  &:hover {
    color: ${({ theme }) => theme.color.brand01};
  }
`;

export const NavLinksColumn = styled(Column)`
  padding-left: 29px;
`;

export const CTALinksColumn = styled(Column)`
  padding-left: 77px;
  ${media.smUp`
    padding-left: 12px;
  `}
`;

export const Icon = styled(CaretRight)`
  &&& {
    width: 12px;
    margin-left: 12px;
  }
`;
export const RegisterButton = styled(Button)`
  text-align: center;
  background-color: white;
  &:hover {
    background-color: white;
  }
  width: 200px;
`;
